import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import {
  FaWhatsapp,
  FaEnvelope,
  FaPhone,
  FaSms,
} from "react-icons/fa";
import useInactivityHandler from "../utils/InactivityHandler";

const ContactUs = () => {
  const { fullname } = useAuth();
  const [showContactInfo, setShowContactInfo] = useState(null);
  useInactivityHandler();

  useEffect(() => {
    const disableRightClick = (e) => e.preventDefault();
    document.addEventListener("contextmenu", disableRightClick);

    return () => {
      document.removeEventListener("contextmenu", disableRightClick);
    };
  }, []);

  const contactOptions = [
    {
      icon: <FaWhatsapp size={40} className="text-green-600" />,
      title: "WhatsApp",
      subtitle: "Message our support team",
      action: () =>
        window.open(
          `https://api.whatsapp.com/send?phone=254757955446&text=Hello, I need support.`
        ),
    },
    {
      icon: <FaSms size={40} className="text-pink-500" />,
      title: "Messages",
      subtitle: "Send an SMS to our support team",
      action: () => setShowContactInfo("SMS: +254 792 673 175"),
    },
    {
      icon: <FaPhone size={40} className="text-teal-600" />,
      title: "Phone",
      subtitle: "Call our support team",
      action: () => setShowContactInfo("Phone: +254 792 673 175"),
    },
    {
      icon: <FaEnvelope size={40} className="text-pink-500" />,
      title: "Email",
      subtitle: "Send an email to our support team",
      action: () =>
        window.open(
          `mailto:8gg@money8gg.com?subject=Support for money8gg&body=${fullname}`
        ),
    },
  ];

  return (
    <div className="min-h-screen flex flex-col items-center bg-gray-100 p-6 z-50">
      {/* sx={{
        zIndex:1300,
      }} */}
      <h2 className="text-2xl font-bold mb-6">Contact Us</h2>
      <div className="space-y-4 w-full max-w-md">
        {contactOptions.map((option, index) => (
          <div
            key={index}
            className="flex items-center p-4 bg-white rounded-lg shadow-md cursor-pointer hover:shadow-lg transition"
            onClick={option.action}
          >
            {option.icon}
            <div className="ml-4">
              <h3 className="font-semibold text-lg">{option.title}</h3>
              <p className="text-gray-600">{option.subtitle}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Contact Info Popup */}
      {showContactInfo && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full">
            <h3 className="text-xl font-bold mb-4">Contact Information</h3>
            <p className="mb-4">{showContactInfo}</p>
            <button
              className="bg-teal-600 text-white py-2 px-4 rounded-md hover:bg-teal-700 transition"
              onClick={() => setShowContactInfo(null)}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ContactUs;
